import React from "react";
import style from "./style.module.css";

export interface ITeamMember {
    name: string;
    picUrl: string;
    portfolioUrl: string;
    linkedInUrl: string;
    blurb: string;
}

export interface ITeamMemberProps {
    member: ITeamMember;
}

export function TeamMember(props: ITeamMemberProps) {
    return (
        <section className={style.member}>
            <h4 className={style.name}>{props.member.name}</h4>
            <img className={style.pic} src={props.member.picUrl} alt={`${props.member.name}`} />
            <section className={style.contact}>
                <a
                    href={props.member.portfolioUrl}
                    className={style.link}
                >
                    Portfolio
                </a>
                <span> | </span>
                <a
                    href={props.member.linkedInUrl}
                    className={style.link}
                >
                    LinkedIn
                </a>
            </section>
            <p className={style.blurb}>{props.member.blurb}</p>
        </section>
    )
}